import React from 'react'

/* Styles */
import './Switching.css'

/* Modules */
import { Avatar, Select, Button, Spin, Modal, List, Input } from 'antd'
import Paper from 'material-ui/Paper'

const SwitchingView = (props) => {
    /* Define column one of round of 16 confrontations */
    let roundOf16Competitors01 = props.roundOf16Competitors.map((competitor, index) => {

        /* Separate columns from the switch */
        if (competitor.colunaUm) {

            /* Change the color if competitor is fit */
            let localColor = ''
            if (!competitor.apto)
                localColor = 'red'

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if (index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Change margin top/bottom to separate confrontations */
            let localMarginBottom = '5px'
            if (index % 2 !== 0)
                localMarginBottom = '15px'

            /* Define additional to pointer the loser competitor */
            let localAddKeyLose = 1
            if (index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Show cancel option */
            let localDisplayBlockNone = 'block'
            if (competitor.nome === '')
                localDisplayBlockNone = 'none'

            return (
                <div
                    key={index}
                    className="switchingSubBlock01"
                    style={{ backgroundColor: localBgColor, color: localColor, marginBottom: localMarginBottom }}
                >
                    <div
                        style={{ display: 'block', width: '80%', cursor: 'pointer' }}
                        className='sharedTextIntoDiv'
                        onClick={() => props.chooseACompetitor(index, index, index + localAddKeyLose, 'roundOf16', competitor)}
                    > &nbsp;{competitor.nome}&nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', float: 'left', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    <div
                        className='switchingClearButton'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer' }}
                        onClick={() => props.clearCompetitor(index, 'roundOf16')}
                    >X</div>
                </div>
            )
        } else { return null }
    })

    /* Draw lines between round of 16 and quarter finals  */
    let linesBetweenRoundOf16AndQuarterFinals01 = props.arrayForLines01.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '17.5625px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '39.125px', borderBottomStyle: 'solid', borderRightStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '31.5625px', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    let linesBetweenRoundOf16AndQuarterFinals02 = props.arrayForLines01.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '36.625px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '52.625px', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    let linesBetweenRoundOf16AndQuarterFinals03 = props.arrayForLines01.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '17.5625px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '39.125px', borderBottomStyle: 'solid', borderLeftStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '31.5625px', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    /* Define column one of quarter finals confrontations */
    let quarterFinalsCompetitors01 = props.quarterFinalsCompetitors.map((competitor, index) => {

        /* Separate columns from the switch */
        if (competitor.colunaUm) {

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if (index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Define additional to pointer the loser competitor */
            let localAddKeyLose = 1
            if (index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            let localColor = ''
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Change margin top/bottom to separate confrontations */
            let localMarginTop = '20.0625px'
            if (index !== 0)
                localMarginTop = '54.625px'

            /* Show cancel option */
            let localDisplayBlockNone = 'block'
            if (competitor.nome === '')
                localDisplayBlockNone = 'none'

            return (
                <div
                    key={index}
                    className="switchingSubBlock02"
                    style={{ backgroundColor: localBgColor, marginTop: localMarginTop, color: localColor }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ float: 'left', width: '80%', cursor: 'pointer' }}
                        onClick={() => props.chooseACompetitor(index, index, index + localAddKeyLose, 'quarterFinals', competitor)}
                    > &nbsp;{competitor.nome}&nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', float: 'left', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    <div
                        className='switchingClearButton'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer' }}
                        onClick={() => props.clearCompetitor(index, 'quarterFinals')}
                    >X</div>
                </div>
            )
        } else { return null }
    })

    /* Draw lines between quarter finals and semi finals  */
    let linesBetweenQuarterAndSemiFinals01 = props.arrayForLines02.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '36.625px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '89.75px', borderBottomStyle: 'solid', borderRightStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '53.1875px', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    let linesBetweenQuarterAndSemiFinals02 = props.arrayForLines02.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '82.75px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '96.5px', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    let linesBetweenQuarterAndSemiFinals03 = props.arrayForLines02.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '36.625px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '89.75px', borderBottomStyle: 'solid', borderLeftStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '53.1875px', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    /* Define column one of semi finals confrontations */
    let semiFinalsCompetitors01 = props.semiFinalsCompetitors.map((competitor, index) => {

        /* Separate columns from the switch */
        if (competitor.colunaUm) {

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if (index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Define additional to pointer the loser competitor */
            let localAddKeyLose = 1
            if (index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            let localColor = ''
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Change margin top/bottom to separate confrontations */
            let localMarginTop = '66.1875px'
            if (index !== 0)
                localMarginTop = '143.9375px'

            /* Show cancel option */
            let localDisplayBlockNone = 'block'
            if (competitor.nome === '')
                localDisplayBlockNone = 'none'

            return (
                <div
                    key={index}
                    className="switchingSubBlock03"
                    style={{ backgroundColor: localBgColor, marginTop: localMarginTop, cursor: 'pointer', color: localColor }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ float: 'left', width: '80%', cursor: 'pointer' }}
                        onClick={() => props.chooseACompetitor(index, index, index + localAddKeyLose, 'semiFinals', competitor)}
                    > {competitor.nome} &nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', float: 'left', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    <div
                        className='switchingClearButton'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer' }}
                        onClick={() => props.clearCompetitor(index, 'semiFinals')}
                    >X</div>
                </div>
            )
        } else { return null }
    })

    /* Draw lines between semi finals and final  */
    let linesBetweenSemiAndFinal01 = props.arrayForLines03.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '82.75px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '179.5px', borderBottomStyle: 'solid', borderRightStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    let linesBetweenSemiAndFinal02 = props.arrayForLines03.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '172.5px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    let linesBetweenSemiAndFinal03 = props.arrayForLines03.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '82.75px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '179.5px', borderBottomStyle: 'solid', borderLeftStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    /* Define column one of final confrontations */
    let finalCompetitors01 = props.finalCompetitors.map((competitor, index) => {

        /* Separate columns from the switch */
        if (competitor.colunaUm) {

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if (index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Define additional to pointer the loser competitor */
            let localAddKeyLose = 1
            if (index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            let localColor = ''
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Show cancel option */
            let localDisplayBlockNone = 'block'
            if (competitor.nome === '')
                localDisplayBlockNone = 'none'

            return (
                <div
                    key={index}
                    className="switchingSubBlock04"
                    style={{ backgroundColor: localBgColor, marginTop: '155.4375px', color: localColor }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ float: 'left', width: '80%', cursor: 'pointer' }}
                        onClick={() => props.chooseACompetitor(index, index, index + localAddKeyLose, 'final', competitor)}
                    > &nbsp; {competitor.nome} &nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', float: 'left', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    <div
                        className='switchingClearButton'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer' }}
                        onClick={() => props.clearCompetitor(index, 'final')}
                    >X</div>
                </div>
            )
        } else { return null }
    })

    /* Define column two of round of 16 confrontations */
    let roundOf16Competitors02 = props.roundOf16Competitors.map((competitor, index) => {

        /* Separate columns from the switch */
        if (!competitor.colunaUm) {

            /* Change the color if competitor is fit */
            let localColor = ''
            if (!competitor.apto)
                localColor = 'red'

            /* Change margin top/bottom to separate confrontations */
            let localBgColor = 'white'
            if (index % 2 === 0) {
                localBgColor = 'gainsboro'
            }

            /* Change margin top/bottom to separate confrontations */
            let localMarginBottom = '5px'
            if (index % 2 !== 0)
                localMarginBottom = '15px'

            /* Define additional to pointer the loser competitor */
            let localAddKeyLose = 1
            if (index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Show cancel option */
            let localDisplayBlockNone = 'block'
            if (competitor.nome === '')
                localDisplayBlockNone = 'none'

            return (
                <div
                    key={index}
                    className="switchingSubBlock01"
                    style={{ backgroundColor: localBgColor, color: localColor, marginBottom: localMarginBottom }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', cursor: 'pointer' }}
                        onClick={() => props.chooseACompetitor(index, index, index + localAddKeyLose, 'roundOf16', competitor)}
                    > &nbsp;{competitor.nome}&nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', float: 'left', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    <div
                        className='switchingClearButton'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer' }}
                        onClick={() => props.clearCompetitor(index, 'roundOf16')}
                    >X</div>
                </div>
            )
        } else { return null }
    })

    /* Define column two of quarter finals confrontations */
    let quarterFinalsCompetitors02 = props.quarterFinalsCompetitors.map((competitor, index) => {

        /* Separate columns from the switch */
        if (!competitor.colunaUm) {

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if (index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Define additional to pointer the loser competitor */
            let localAddKeyLose = 1
            if (index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            let localColor = ''
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Change margin top/bottom to separate confrontations */
            let localMarginTop = '20.0625px'
            if (index !== 2)
                localMarginTop = '54.625px'

            /* Show cancel option */
            let localDisplayBlockNone = 'block'
            if (competitor.nome === '')
                localDisplayBlockNone = 'none'

            return (
                <div
                    key={index}
                    className="switchingSubBlock02"
                    style={{ backgroundColor: localBgColor, marginTop: localMarginTop, cursor: 'pointer', color: localColor }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ float: 'left', width: '80%', cursor: 'pointer' }}
                        onClick={() => props.chooseACompetitor(index, index, index + localAddKeyLose, 'quarterFinals', competitor)}
                    > &nbsp; {competitor.nome} &nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', float: 'left', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    <div
                        className='switchingClearButton'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer' }}
                        onClick={() => props.clearCompetitor(index, 'quarterFinals')}
                    >X</div>
                </div>
            )
        } else { return null }
    })

    /* Define column two of semi finals confrontations */
    let semiFinalsCompetitors02 = props.semiFinalsCompetitors.map((competitor, index) => {

        /* Separate columns from the switch */
        if (!competitor.colunaUm) {

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if (index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Define additional to pointer the loser competitor */
            let localAddKeyLose = 1
            if (index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            let localColor = ''
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Change margin top/bottom to separate confrontations */
            let localMarginTop = '66.1875px'
            if (index !== 2)
                localMarginTop = '143.9375px'

            /* Show cancel option */
            let localDisplayBlockNone = 'block'
            if (competitor.nome === '')
                localDisplayBlockNone = 'none'

            return (
                <div
                    key={index}
                    className="switchingSubBlock03"
                    style={{ backgroundColor: localBgColor, marginTop: localMarginTop, cursor: 'pointer', color: localColor }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ float: 'left', width: '80%', cursor: 'pointer' }}
                        onClick={() => props.chooseACompetitor(index, index, index + localAddKeyLose, 'semiFinals', competitor)}
                    > &nbsp; {competitor.nome} &nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', float: 'left', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    <div
                        className='switchingClearButton'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer' }}
                        onClick={() => props.clearCompetitor(index, 'semiFinals')}
                    >X</div>
                </div>
            )
        } else { return null }
    })

    /* Define column two of final confrontations */
    let finalCompetitors02 = props.finalCompetitors.map((competitor, index) => {

        /* Separate columns from the switch */
        if (!competitor.colunaUm) {

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if (index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Define additional to pointer the loser competitor */
            let localAddKeyLose = 1
            if (index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            let localColor = ''
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Show cancel option */
            let localDisplayBlockNone = 'block'
            if (competitor.nome === '')
                localDisplayBlockNone = 'none'

            return (
                <div
                    key={index}
                    className="switchingSubBlock04"
                    style={{ backgroundColor: localBgColor, marginTop: '155.4375px', color: localColor }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ float: 'left', width: '80%', cursor: 'pointer' }}
                        onClick={() => props.chooseACompetitor(index, index, index + localAddKeyLose, 'final', competitor)}
                    > &nbsp; {competitor.nome} &nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', float: 'left', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    <div
                        className='switchingClearButton'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer' }}
                        onClick={() => props.clearCompetitor(index, 'final')}
                    >X</div>
                </div>
            )
        } else { return null }
    })

    let arrayOfTeams = props.arrayOfTeamsToSelect.map(team => {
        return (
            <Select.Option key={team.__key} value={team.nome}>{team.nome}</Select.Option>
        )
    })

    let arrayOfTeamsWithScore = props.arrayOfTeamsWithScore.map((team, index) => {

        /* Show only team with score */
        if (team.score !== 0) {
            return (
                <div key={index} style={{ margin: '20px' }}>
                    {team.team}: {team.score} pontos
                </div>
            )
        } else { return null }
    })

    let arrayOfCompetitorsWithScore01 = props.finalCompetitors.map((competitor, index) => {

        /* Show only if there are competitors with score */
        if (competitor.nome !== '' && props.finalCompetitors[1].nome !== '') {
            return (
                <div key={index} style={{ margin: '20px' }}>
                    {competitor.nome}: {competitor.score} pontos
                </div>
            )
        } else { return null }
    })

    let arrayOfCompetitorsWithScore02 = props.semiFinalsCompetitors.map((competitor, index) => {

        /* Show only if there are competitors with score */
        if (competitor.nome !== '') {
            /* Show only competitor with score */
            if (competitor.score && competitor.score !== 0) {
                return (
                    <div key={index} style={{ margin: '20px' }}>
                        {competitor.nome}: {competitor.score} pontos
                    </div>
                )
            } else { return null }
        } else { return null }
    })

    return (
        <div id='champContent'>
            {props.loading ?
                <Spin style={{ marginTop: '50px', width: '100%' }} /> :
                <div>
                    <div className="switchingTitle" id='printAreaOfSwitching'>

                        <div style={{ marginBottom: 0 }} id='switchingFiltersChoosen'>

                            <div style={{ color: 'gray', fontSize: 'small', marginBottom: '30px', marginTop: '30px', display: 'block', fontWeight: 'lighter', textAlign: 'center' }}>
                                <div style={{ marginBottom: '10px' }} onClick={props.showFilters}>
                                    <a>
                                        <i className="fas fa-info-circle"></i> Abrir painel de configurações
                                    </a>
                                </div>


                                <Avatar
                                    style={{ backgroundColor: props.studentFaixa }}
                                    size='small'
                                    shape='square'
                                ></Avatar>&nbsp; &nbsp;
                                <span style={{ fontSize: 'x-large' }}>{props.switchingId > 100 ? 'Chave absoluto ' + (props.switchingId - 100) : 'Chave ' + props.switchingId}</span><br /><br />


                                Sexo: {props.studentSexo} |&nbsp;
                                Peso: {props.studentPeso} |&nbsp;
                                Idade: {props.studentIdade}

                            </div>
                        </div>

                        <Paper className="switchingInfoBlock" zDepth={2} style={{ display: 'none', width: '95%', marginLeft: '2.5%' }} id='switchingFilters'>
                            <div className="switchingContentInfoBlock">
                                {/*
                                <h3>
                                    {props.switchingId > 100 ? 'Chave absoluto ' + (props.switchingId - 100) : 'Chave ' + props.switchingId}
                                </h3>
                                */}

                                <Select
                                    className='SwitchingInputFilter'
                                    showSearch
                                    placeholder="Filtrar Sexo"
                                    optionFilterProp="children"
                                    defaultValue={props.studentSexo}
                                    onChange={props.fieldSexoToFilter}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Select.Option value={null}> </Select.Option>
                                    <Select.Option value='Masculino'>Masculino</Select.Option>
                                    <Select.Option value='Feminino'>Feminino</Select.Option>
                                </Select>

                                <Select
                                    className='SwitchingInputFilter'
                                    showSearch
                                    placeholder="Filtrar Faixa"
                                    optionFilterProp="children"
                                    defaultValue={props.studentFaixa}
                                    onChange={props.fieldFaixaToFilter}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Select.Option value={null}> </Select.Option>
                                    <Select.Option value="whiteSmoke">Branca</Select.Option>
                                    <Select.Option value="grey">Cinza</Select.Option>
                                    <Select.Option value="yellow">Amarela</Select.Option>
                                    <Select.Option value="orange">Laranja</Select.Option>
                                    <Select.Option value="green">Verde</Select.Option>
                                    <Select.Option value="#ffcc99">Colorido</Select.Option>
                                    <Select.Option value="blue">Azul</Select.Option>
                                    <Select.Option value="purple">Roxa</Select.Option>
                                    <Select.Option value="brown">Marrom</Select.Option>
                                    <Select.Option value="black">Preta</Select.Option>
                                </Select>

                                <Select
                                    className='SwitchingInputFilter'
                                    showSearch
                                    placeholder="Filtrar Peso"
                                    optionFilterProp="children"
                                    defaultValue={props.studentPeso}
                                    onChange={props.fieldPesoToFilter}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Select.Option value={null}> </Select.Option>
                                    <Select.Option value="Galo">Galo</Select.Option>
                                    <Select.Option value="Pluma">Pluma</Select.Option>
                                    <Select.Option value="Pena">Pena</Select.Option>
                                    <Select.Option value="Leve">Leve</Select.Option>
                                    <Select.Option value="Médio">Médio</Select.Option>
                                    <Select.Option value="Meio Pesado">Meio Pesado</Select.Option>
                                    <Select.Option value="Pesado">Pesado</Select.Option>
                                    <Select.Option value="Super Pesado">Super Pesado</Select.Option>
                                    <Select.Option value="Pesadíssimo">Pesadíssimo</Select.Option>
                                </Select>

                                <Select
                                    className='SwitchingInputFilter'
                                    showSearch
                                    placeholder="Filtrar Idade"
                                    optionFilterProp="children"
                                    defaultValue={props.studentIdade}
                                    onChange={props.fieldIdadeToFilter}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Select.Option value={undefined}> </Select.Option>
                                    <Select.Option value="Pré-Mirim">Pré-Mirim</Select.Option>
                                    <Select.Option value="Mirim 1">Mirim 1</Select.Option>
                                    <Select.Option value="Mirim 2">Mirim 2</Select.Option>
                                    <Select.Option value="Infantil 1">Infantil 1</Select.Option>
                                    <Select.Option value="Infantil 2">Infantil 2</Select.Option>
                                    <Select.Option value="Infanto 1">Infanto 1</Select.Option>
                                    <Select.Option value="Infanto 2">Infanto 2</Select.Option>
                                    {/*
                                    <Select.Option value="Mirim">Mirim</Select.Option>
                                    <Select.Option value="Infantil">Infantil</Select.Option>
                                    <Select.Option value="Infanto">Infanto</Select.Option>
                                    */}
                                    <Select.Option value="Juvenil">Juvenil</Select.Option>
                                    <Select.Option value="Adulto">Adulto</Select.Option>
                                    {/*
                                    <Select.Option value="Master">Master</Select.Option>
                                    */}
                                    <Select.Option value="Master 1">Master 1</Select.Option>
                                    <Select.Option value="Master 2">Master 2</Select.Option>
                                </Select>

                                <Button
                                    onClick={props.clearSwitching}
                                    className='SwitchingButtonFilterBlock'
                                >Limpar</Button>

                                <Button
                                    onClick={() => props.createSwitching(false)}
                                    className='SwitchingButtonFilterBlock'
                                >Gerar confrontos</Button>

                                <Button
                                    onClick={props.openScoreDialog}
                                    className='SwitchingButtonFilterBlock'
                                >Ver pontuação</Button>

                                <Button
                                    type='primary'
                                    onClick={props.saveSwitching}
                                    loading={props.loadingSave}
                                    className='SwitchingButtonFilterBlock'
                                >Salvar</Button>

                                <br />

                                <a onClick={props.hideFilters}>
                                    <i className="fas fa-info-circle"></i> Ocultar painel de configurações
                                </a>
                            </div>
                            <div style={{ clear: 'both' }}></div>
                        </Paper>

                        <div className='SwitchingContent'>
                            <div className='switchingRanking'> {props.champion !== undefined ? props.champion.substring(0, 20) : ''} </div>
                            <div className='SwitchingContentSub'>


                                <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                                    {roundOf16Competitors01}
                                </div>

                                <div className='switchingBetweenBlock'> {linesBetweenRoundOf16AndQuarterFinals01} </div>
                                <div className='switchingBetweenBlock'> {linesBetweenRoundOf16AndQuarterFinals02} </div>

                                <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                                    {quarterFinalsCompetitors01}
                                </div>

                                <div className='switchingBetweenBlock'> {linesBetweenQuarterAndSemiFinals01} </div>
                                <div className='switchingBetweenBlock'> {linesBetweenQuarterAndSemiFinals02} </div>

                                <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                                    {semiFinalsCompetitors01}
                                </div>

                                <div className='switchingBetweenBlock'> {linesBetweenSemiAndFinal01} </div>
                                <div className='switchingBetweenBlock'> {linesBetweenSemiAndFinal02} </div>

                                <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                                    {finalCompetitors01}
                                </div>

                                <div className='switchingBetweenBlock'>&nbsp;</div>

                                <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                                    {finalCompetitors02}
                                </div>

                                <div className='switchingBetweenBlock'> {linesBetweenSemiAndFinal02} </div>
                                <div className='switchingBetweenBlock'> {linesBetweenSemiAndFinal03} </div>

                                <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                                    {semiFinalsCompetitors02}
                                </div>

                                <div className='switchingBetweenBlock'> {linesBetweenQuarterAndSemiFinals02} </div>
                                <div className='switchingBetweenBlock'> {linesBetweenQuarterAndSemiFinals03} </div>

                                <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                                    {quarterFinalsCompetitors02}
                                </div>

                                <div className='switchingBetweenBlock'> {linesBetweenRoundOf16AndQuarterFinals02} </div>
                                <div className='switchingBetweenBlock'> {linesBetweenRoundOf16AndQuarterFinals03} </div>

                                <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                                    {roundOf16Competitors02}
                                </div>

                            </div>
                        </div>

                        <div style={{ clear: 'both' }}></div>

                        {/* <div className='SwitchingObs'>Deslize para o lado para ver os demais confrontos</div> */}
                        <iframe title="ifmcontentstoprint_switching" id="ifmcontentstoprint_switching" style={{ height: '0px', width: '0px', position: 'absolute' }}></iframe>
                    </div>
                    <div style={{ textAlign: 'center', width: '100%' }} >
                        <Button type='primary' onClick={() => props.renderPdf()}>Imprimir</Button>
                    </div>
                </div>
            }

            <Modal
                title="Pontuação"
                visible={props.scoreDialog}
                onCancel={props.closeScoreDialog}
                onOk={props.closeScoreDialog}
            >
                Equipes
                {arrayOfTeamsWithScore}<hr />

                Competidores
                {arrayOfCompetitorsWithScore01}
                {arrayOfCompetitorsWithScore02}
            </Modal>

            <Modal
                title="Alunos inscritos"
                width={800}
                visible={props.addStudentManuallyDialog}
                onCancel={props.closeAddStudentManuallyDialog}
                footer={[]}
            >
                <div className="sharedSearchListBlock">
                    <div>
                        <div className='switchingLabel' style={{ width: '26%' }}>Faixa:</div>
                        <div className='switchingLabel' style={{ width: '25%' }}>Peso:</div>
                        <div className='switchingLabel' style={{ width: '26%' }}>Idade:</div>
                        <div className='switchingLabel' style={{ width: '23%' }}>Equipe:</div>
                    </div>
                    <Select
                        className='SwitchingInputFilter'
                        showSearch
                        placeholder="Filtrar Faixa"
                        optionFilterProp="children"
                        onChange={props.chooseAFaixaFilter}
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                        <Select.Option value={null}> </Select.Option>
                        <Select.Option value="whiteSmoke">Branca</Select.Option>
                        <Select.Option value="grey">Cinza</Select.Option>
                        <Select.Option value="yellow">Amarela</Select.Option>
                        <Select.Option value="orange">Laranja</Select.Option>
                        <Select.Option value="green">Verde</Select.Option>
                        <Select.Option value="#ffcc99">Colorido</Select.Option>
                        <Select.Option value="blue">Azul</Select.Option>
                        <Select.Option value="purple">Roxa</Select.Option>
                        <Select.Option value="brown">Marrom</Select.Option>
                        <Select.Option value="black">Preta</Select.Option>
                    </Select>

                    <Select
                        className='SwitchingInputFilter'
                        showSearch
                        placeholder="Filtrar Peso"
                        optionFilterProp="children"
                        onChange={props.filterPeso}
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                        <Select.Option value={null}> </Select.Option>
                        <Select.Option value="Galo">Galo</Select.Option>
                        <Select.Option value="Pluma">Pluma</Select.Option>
                        <Select.Option value="Pena">Pena</Select.Option>
                        <Select.Option value="Leve">Leve</Select.Option>
                        <Select.Option value="Médio">Médio</Select.Option>
                        <Select.Option value="Meio Pesado">Meio Pesado</Select.Option>
                        <Select.Option value="Pesado">Pesado</Select.Option>
                        <Select.Option value="Super Pesado">Super Pesado</Select.Option>
                        <Select.Option value="Pesadíssimo">Pesadíssimo</Select.Option>
                    </Select>

                    <Select
                        className='SwitchingInputFilter'
                        showSearch
                        placeholder="Filtrar Idade"
                        optionFilterProp="children"
                        onChange={props.chooseAIdadeFilter}
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                        <Select.Option value={undefined}> </Select.Option>
                        <Select.Option value="Pré-Mirim">Pré-Mirim</Select.Option>
                        <Select.Option value="Mirim 1">Mirim 1</Select.Option>
                        <Select.Option value="Mirim 2">Mirim 2</Select.Option>
                        <Select.Option value="Infantil 1">Infantil 1</Select.Option>
                        <Select.Option value="Infantil 2">Infantil 2</Select.Option>
                        <Select.Option value="Infanto 1">Infanto 1</Select.Option>
                        <Select.Option value="Infanto 2">Infanto 2</Select.Option>
                        {/*
                        <Select.Option value="Mirim">Mirim</Select.Option>
                        <Select.Option value="Infantil">Infantil</Select.Option>
                        <Select.Option value="Infanto">Infanto</Select.Option>
                        */}
                        <Select.Option value="Juvenil">Juvenil</Select.Option>
                        <Select.Option value="Adulto">Adulto</Select.Option>
                        {/*
                        <Select.Option value="Master">Master</Select.Option>
                        */}
                        <Select.Option value="Master 1">Master 1</Select.Option>
                        <Select.Option value="Master 2">Master 2</Select.Option>
                    </Select>

                    <Select
                        className='SwitchingInputFilter'
                        showSearch
                        placeholder="Filtrar Equipe"
                        optionFilterProp="children"
                        onChange={props.chooseAEquipeFilter}
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                        <Select.Option value={null}></Select.Option>
                        {arrayOfTeams}
                    </Select>

                    <Input
                        placeholder="Buscar aluno"
                        onKeyUp={input => props.searchStudent(input.target.value)}
                        id="searchInput"
                        className='sharedInput'
                        style={{ width: '100%', marginBottom: '20px' }}
                    />

                    <List
                        className="demo-loadmore-list"
                        itemLayout="horizontal"
                        dataSource={props.filteredArrayOfStudents}
                        loading={props.loading}
                        renderItem={competitor => (
                            <List.Item>
                                <List.Item.Meta
                                    style={{ fontSize: 'x-small' }}
                                    avatar={<Avatar size='small' style={{ backgroundColor: competitor.faixa }} />}
                                    title={competitor.nome}
                                    description={competitor.peso + ' | ' + competitor.idade + ' | ' + competitor.equipe}
                                />
                                <div style={{ cursor: 'pointer' }} onClick={() => props.putStudentInSwitching(competitor)}>
                                    Adicionar
                                </div>
                            </List.Item>
                        )}
                    />
                </div>

            </Modal>
        </div>
    )
}

export default SwitchingView